'use client'

import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { useSelectedLayoutSegment } from 'next/navigation'
import classNames from 'classnames'
import { SparklesIcon } from '@heroicons/react/24/outline'

type MaasNavProps = {
  className?: string
}

const MaasNav = ({ className }: MaasNavProps) => {
  const { t } = useTranslation()
  const selectedSegment = useSelectedLayoutSegment()
  const actived = selectedSegment === 'maas'

  return (
    <Link
      href='/maas/models'
      className={classNames(
        className,
        'group',
        actived && 'bg-white shadow-md',
        actived ? 'text-primary-600' : 'text-gray-500 hover:bg-gray-200',
      )}>
      {actived ? (
        <SparklesIcon className='mr-2 w-4 h-4' />
      ) : (
        <SparklesIcon className='mr-2 w-4 h-4' />
      )}
      {t('common.menus.modelService')}
    </Link>
  )
}

export default MaasNav
